import { render, staticRenderFns } from "./branchInitiateForm.vue?vue&type=template&id=858ddf1e"
import script from "./branchInitiateForm.vue?vue&type=script&lang=js"
export * from "./branchInitiateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports